import {
  ReportSubscription,
  ListReportSubscriptionsResponse,
} from '@/@types/report-subscription';
import {
  EmptyData,
  ErrorList,
  ListPlaceholder,
  ResponseDataHandle,
} from '@/components/common';
import { ITablePaginationProps } from '@/components/common/Table/TablePagination';
import { Box } from '@mui/material';
import { ReportSubscriptionsTable } from '../ReportSubscriptionsTable';
import { ReportSubscriptionsTableColumns } from '../ReportSubscriptionsTable/ReportSubscriptionsTableColumns';

interface ReportSubscriptionsListProps {
  isLoading: boolean;
  isError: boolean;
  data: ListReportSubscriptionsResponse | undefined;
  sort?: 'desc' | 'asc';
  sortBy?: keyof ReportSubscription;
  // eslint-disable-next-line no-unused-vars
  onSort?: (header: string) => void;
  actions: object;
  pagination?: ITablePaginationProps;
}

export function ReportSubscriptionsList({
  isLoading,
  isError,
  data,
  sort,
  sortBy,
  onSort,
  actions,
  pagination,
}: ReportSubscriptionsListProps) {
  return (
    <ResponseDataHandle
      isLoading={isLoading}
      loadingComponent={
        <ListPlaceholder
          headers={[
            'Usuário',
            'Relatório',
            'Frequência',
            'Status',
            'Criado em',
            'Ações',
          ]}
        />
      }
      isError={isError}
      errorComponent={
        <Box py={10}>
          <ErrorList text="Falha ao obter os dados das assinaturas de relatório." />
        </Box>
      }
      totalItems={data?.totalCount}
      emptyComponent={
        <Box py={10}>
          <EmptyData />
        </Box>
      }
    >
      <ReportSubscriptionsTable
        columns={ReportSubscriptionsTableColumns}
        data={data?.reportSubscriptions || []}
        sort={sort}
        sortBy={sortBy}
        onSort={onSort}
        actions={actions}
        pagination={pagination}
      />
    </ResponseDataHandle>
  );
}
